import { Injectable } from "@angular/core";
import { firstValueFrom, Observable, Subscription, take } from "rxjs";
import { CitronellaImgDataResponse } from "../../models/ExternalAPI/CitronellaImgDataResponse";
import { ThirdPartySettingsAPIService } from "../API/ThirdPartySettingsAPI.service";

@Injectable({
  providedIn: "root",
})
export class ThirdPartySettingsService {

  constructor(
    private thirdPartySettingsService: ThirdPartySettingsAPIService,
  ) {}


  getCitronellaImagesSettings() {
    return this.thirdPartySettingsService.getCitronellaImagesSettings();
  }
}
